import {EventEmitter} from "events"

const EventBus = new EventEmitter();

EventBus.setMaxListeners(10);

export default EventBus;
